/* import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AllocationDefinition} from '../domain/allocationdefinition';
import { MessageService } from 'primeng/api';
import { Configuration } from '../domain/configuration';
import { AllocationItem } from '../domain/allocationitem';
import { AllocationDefinitionLine } from '../domain/allocationdefinitionline';
import { AllocationDefinitionImportLine } from '../domain/allocationdefinitionimportline';

@Injectable()
export class AllocationDefinitionService {


    uri = '/api/allocation';

    constructor(private http: HttpClient, private messageService: MessageService) {}

    get(companyId : number) : Promise<AllocationDefinition[]> {
        const promise = this.http.get<AllocationDefinition[]>(`${this.apiUrl}${this.uriPath}/definitions/${companyId}`)
                          .toPromise();
        return promise;
    }

    getById(id : number) : Promise<AllocationDefinition> {
        const promise = this.http.get<AllocationDefinition>(`${this.apiUrl}${this.uriPath}/${id}`)
                          .toPromise();
        return promise;
    }

    update(obj: AllocationDefinition) {
        const promise =  this.http
                           .post<AllocationDefinition>(`${this.apiUrl}${this.uriPath}`, obj )
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Allocation definition saved' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: error.error })
        });
        return promise;
    }

    delete(id : number) : Promise<AllocationDefinition[]> {
        const promise = this.http.delete<AllocationDefinition[]>(`${this.apiUrl}${this.uriPath}/${id}`)
                          .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Allocation Definition deleted', detail: 'Allocation definition saved' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Deleting Allocation Definition failed', detail: error.status + ':' + error.message })
        });
        return promise;
    }

    getAllReportLines(companyId : number) : Promise<AllocationItem[]> {
        const promise = this.http.get<AllocationItem[]>(`${this.apiUrl}${this.uriPath}/getAllReportLines/${companyId}`)
                          .toPromise();
        return promise;
    }

    getLines(allocationDefinitionId : number, year: number) : Promise<AllocationDefinitionLine[]> {
        const promise = this.http.get<AllocationDefinitionLine[]>(`${this.apiUrl}${this.uriPath}/lines/${allocationDefinitionId}/${year}`)
                          .toPromise();
        return promise;
    }

    setLines(allocationDefinitionId : number, year: number, lines: AllocationDefinitionLine[]) : Promise<AllocationDefinitionLine[]> {
        const promise = this.http.post<AllocationDefinitionLine[]>(`${this.apiUrl}${this.uriPath}/lines/set/${allocationDefinitionId}/${year}`, lines)
                          .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Lines saved' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Saving lines failed', detail: error.status + ':' + error.message })
        });
        return promise;
    }

    importLines(line: AllocationDefinitionImportLine) : Promise<boolean> {
        const promise = this.http.post<any>(`${this.apiUrl}${this.uriPath}/importAllocationDefinitionLine`, line).toPromise();
        
        return promise;
    }
} 
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { catchError, tap } from 'rxjs/operators';
import { DynamicBackendConfigService } from './dynamic-backend-config.service';
import { AllocationDefinition } from '../domain/allocationdefinition';
import { AllocationItem } from '../domain/allocationitem';
import { AllocationDefinitionLine } from '../domain/allocationdefinitionline';
import { AllocationDefinitionImportLine } from '../domain/allocationdefinitionimportline';
import { AppConfigService } from './app-config.service';
import { Utils } from "src/app/utilities/utils";
import { Observable } from 'rxjs/internal/Observable';
import { AllocationDefinitionImportLinePreview } from '../domain/allocationdefinitionimportlinepreview';
import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import { AllocationFactorsImportExceptionLog } from '../domain/allocationFactorsImportExceptionLog';
import { throwError } from 'rxjs';


@Injectable()
export class AllocationDefinitionService {

    private uriPath = '/api/allocation';
    uri = '';
    apiUrl = '';
    public dataManager = new DataManager({
        url: 'api-url/getAllReportLinesPreview',
        adaptor: new UrlAdaptor(),
        crossDomain: true
    });

    public dataManagerError = new DataManager({
        url: 'api-url/getAllReportLinesPreview',
        adaptor: new UrlAdaptor(),
        crossDomain: true
    });

    constructor(
        private http: HttpClient,
        private messageService: MessageService,
        private dynamicBackend: DynamicBackendConfigService,
        private appConfigService: AppConfigService
    ) {
        this.apiUrl = this.appConfigService.apiUrl;
        /*this.dynamicBackend.getApiUrl().subscribe(apiUrl => {
            this.uri = this.dynamicBackend.extractSecondURL(apiUrl ? `${apiUrl}${this.uriPath}` : this.uriPath);
        });*/
    }
    get(companyId: number): Promise<AllocationDefinition[]> {
        const promise = this.http.get<AllocationDefinition[]>(`${this.apiUrl}${this.uriPath}/definitions/${companyId}`)
            .toPromise();
        return promise;
    }

    getById(id: number): Promise<AllocationDefinition> {
        const promise = this.http.get<AllocationDefinition>(`${this.apiUrl}${this.uriPath}/${id}`)
            .toPromise();
        return promise;
    }

    update(obj: AllocationDefinition) {
        const promise = this.http
            .post<AllocationDefinition>(`${this.apiUrl}${this.uriPath}`, obj)
            .toPromise();
        promise.then(oa => {
            this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Allocation definition saved' })
        })
            .catch(error => {
                this.messageService.add({ severity: 'error', summary: Utils.extractSQLError(error.error) })
            });
        return promise;
    }

    updateNew(obj: AllocationDefinition) {
        const promise = this.http
            .post<AllocationDefinition>(`${this.apiUrl}${this.uriPath}`, obj)
            .toPromise();

        return promise;
    }

    delete(id: number): Promise<AllocationDefinition[]> {
        const promise = this.http.delete<AllocationDefinition[]>(`${this.apiUrl}${this.uriPath}/${id}`)
            .toPromise();
        promise.then(oa => {
            this.messageService.add({ severity: 'success', summary: 'Allocation Definition deleted', detail: 'Allocation definition saved' })
        })
            .catch(error => {
                this.messageService.add({ severity: 'error', summary: 'Deleting Allocation Definition failed', detail: Utils.extractSQLError(error.error) })
            });
        return promise;
    }

    getAllReportLines(companyId: number): Promise<AllocationItem[]> {
        const promise = this.http.get<AllocationItem[]>(`${this.apiUrl}${this.uriPath}/getAllReportLines/${companyId}`)
            .toPromise();
        return promise;
    }

    getLines(allocationDefinitionId: number, year: number): Promise<AllocationDefinitionLine[]> {
        const promise = this.http.get<AllocationDefinitionLine[]>(`${this.apiUrl}${this.uriPath}/lines/${allocationDefinitionId}/${year}`)
            .toPromise();
        return promise;
    }

    setLines(allocationDefinitionId: number, year: number, lines: AllocationDefinitionLine[]): Promise<AllocationDefinitionLine[]> {
        const promise = this.http.post<AllocationDefinitionLine[]>(`${this.apiUrl}${this.uriPath}/lines/set/${allocationDefinitionId}/${year}`, lines)
            .toPromise();
        promise.then(oa => {
            this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Lines saved' })
        })
            .catch(error => {
                this.messageService.add({ severity: 'error', summary: 'Saving lines failed', detail: Utils.extractSQLError(error.error) })
            });
        return promise;
    }

    setLinesNew(allocationDefinitionId: number, year: number, lines: AllocationDefinitionLine[]): Promise<AllocationDefinitionLine[]> {
        const promise = this.http.post<AllocationDefinitionLine[]>(`${this.apiUrl}${this.uriPath}/lines/set/${allocationDefinitionId}/${year}`, lines)
            .toPromise();

        return promise;
    }

    importLines(line: AllocationDefinitionImportLine): Promise<boolean> {
        const promise = this.http.post<any>(`${this.apiUrl}${this.uriPath}/importAllocationDefinitionLine`, line).toPromise();

        return promise;
    }

    uploadExcel(file: File, user: string, companyId: number, action: string): Promise<any> {
        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams()
            .set('user', user)
            .set('companyId', companyId)
            .set('action', action);

        return this.http
            .post<any>(`${this.apiUrl}${this.uriPath}/upload-excel`, formData, { params })
            .toPromise();
    }
    processExcel(user: string, companyId: number, action: string, sessionGUID: string): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const params = new HttpParams()
            .set('user', user)
            .set('companyId', companyId)
            .set('action', action)
            .set('sessionGUID', sessionGUID);

        return this.http
            .post<any>(`${this.apiUrl}${this.uriPath}/process-excel`, null, {
                headers,
                params,
            })
            .toPromise();
    }

    getAllocationLinesPreview(sessionGuid: string, skip: number, take: number): Promise<{ Data: AllocationDefinitionImportLinePreview[]; TotalCount: number }> {
        return this.http.get<{ Data: AllocationDefinitionImportLinePreview[]; TotalCount: number }>(
            `${this.apiUrl}${this.uriPath}/getAllReportLinesPreview?guid=${sessionGuid}&skip=${skip}&take=${take}`
        ).toPromise();
    }
    getAllocationLinesPreview_old(guid: string): Promise<AllocationDefinitionImportLinePreview[]> {
        const promise = this.http.get<AllocationDefinitionImportLinePreview[]>(`${this.apiUrl}${this.uriPath}/getAllReportLinesPreview/${guid}`)
            .toPromise();
        return promise;
    }

    getAllocationFactorsImportExceptionLog(guid: string): Promise<AllocationFactorsImportExceptionLog[]> {
        const promise = this.http.get<AllocationFactorsImportExceptionLog[]>(`${this.apiUrl}${this.uriPath}/getAllocationFactorsImportExceptionLog/${guid}`)
            .toPromise();
        return promise;
    }

    getDataManager(guid: string) {
        return new DataManager({
            url: `${this.apiUrl}${this.uriPath}/getAllReportLinesPreview/${guid}`,
            adaptor: new UrlAdaptor(),
            crossDomain: true
        });
    }

    getDataManagerError(guid: string) {
        return new DataManager({
            url: `${this.apiUrl}${this.uriPath}/getAllocationFactorsImportExceptionLog/${guid}`,
            adaptor: new UrlAdaptor(),
            crossDomain: true
        });
    }

    downloadFile() {
        return this.http.get(`${this.apiUrl}${this.uriPath}/getFileAllocationTemplate`, {
          responseType: 'blob', // Expect a binary response
        }).pipe(
          catchError((error) => {
            return throwError(() => new Error(error.message || 'An error occurred'));
          })
        );
      }

      getDataManagerLines(allocationDefinitionId: number, year: number) {
        return new DataManager({
            url: `${this.apiUrl}${this.uriPath}/linesSyncfusion/${allocationDefinitionId}/${year}`,
            adaptor: new UrlAdaptor(),
            crossDomain: true, 
            requestType: 'GET'
        });
    }
        

}

